import React from "react";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import ContentLoader from "react-content-loader";
import TypesTags from "./TypesTags";

import loading from "../../img/loading.svg";
import Button from "./Button";
import ContentEditable from "react-contenteditable";

class ChatModal extends React.Component {
  constructor(props) {
    super(props);
    const patientSpan = props.patientId ? (
      <span className="patient-tag-modal">
        {props.patientId.nom} {props.patientId.prenom}
      </span>
    ) : null;
    this.state = {
      patientSpan: patientSpan,
      text: "",
      to: [],
      loading: false,
      error: false
    };
  }
  componentWillReceiveProps(newProps) {}

  handleText = event => {
    this.setState({
      text: event.target.value
    });
  };
  handleUserChange = users => {
    let ids = users.map(u => u.id);
    this.setState({
      to: ids
    });
  };
  send = () => {
    this.setState({ loading: true });
    this.props
      .createMessageMutation({
        variables: {
          text: this.state.text, //.replace(/<br\s*[\/]?>/gi, "\n"), //.replace(/(?:\r\n|\r|\n)/g, "<br>"),
          fromId: this.props.user.id,
          toIds: this.state.to,
          patientId: this.props.patientId ? this.props.patientId.id : null
        }
      })
      .then(ret => {
        this.props.toggleChatModal();
      })
      .catch(e => {
        console.error(e);
        this.setState({
          error: true,
          loading: false
        });
      });
  };

  onEnterPress = e => {
    if (e.keyCode === 13 && e.shiftKey === false) {
      e.preventDefault();
      if (
        !this.state.loading &&
        this.state.to.length > 0 &&
        this.state.text.length > 0
      ) {
        this.send();
      }
    }
  };

  /*
{this.props.patientId ? <span>sldksldk</span> : ""}
{this.state.text}
 */
  render() {
    return (
      <div className="modal is-active">
        <div className="modal-background" />
        <div className="modal-card">
          <header className="modal-card-head">
            <p className="modal-card-title">Nouveau message</p>
          </header>
          <section className="modal-card-body">
            {this.props.getAllUsers.loading ? (
              <ContentLoader type="facebook" />
            ) : (
              <React.Fragment>
                <div className="field">
                  <label className="label">Destinataire: </label>
                  <div className="control">
                    <TypesTags
                      allSlotTypes={this.props.getAllUsers.allUsers}
                      handleTypeTagChange={v => this.handleUserChange(v)}
                      onKeyDown={this.onEnterPress}
                    />
                    {/*}<Select
                      multi={true}
                      name="form-field-name"
                      placeholder="Sélectionnez un utilisateur"
                      value={this.state.to}
                      options={this.props.getAllUsers.allUsers}
                      labelKey="name"
                      valueKey="id"
                      clearable={false}
                      wrapperStyle={{ width: "100%" }}
                      onChange={v => this.handleUserChange(v)}
                    />*/}
                  </div>
                </div>
                <div className="field">
                  <label className="label">Message: </label>
                  <div className="control">
                    {this.state.patientSpan}
                    <ContentEditable
                      innerRef={this.contentEditable}
                      html={this.state.text} // innerHTML of the editable div
                      disabled={false} // use true to disable editing
                      onChange={this.handleText} // handle innerHTML change
                      className="textarea"
                      onKeyDown={this.onEnterPress}
                      style={{ position: "relative" }}
                    />
                  </div>
                </div>
              </React.Fragment>
            )}
          </section>
          <footer className="modal-card-foot">
            {this.state.error ? (
              <p className="has-text-danger">Une erreur est survenue!</p>
            ) : null}
            <Button text="Retour" onClick={this.props.toggleChatModal} />
            <Button
              color="#00893D"
              text="Envoyer"
              onClick={this.send}
              disabled={
                this.state.loading ||
                this.state.to.length === 0 ||
                this.state.text.length === 0
              }
              type="submit"
            />
            {this.state.loading ? (
              <figure className="image is-32x32">
                <img alt="loading" src={loading} />
              </figure>
            ) : null}
          </footer>
        </div>
      </div>
    );
  }
}
const GET_ALL_USERS_QUERY = gql`
  query {
    allUsers(filter: { role_not: ADMIN }) {
      id
      name
      email
    }
  }
`;
const CREATE_MESSAGE_MUTATION = gql`
  mutation CreateMessageMutation(
    $toIds: [ID!]!
    $text: String!
    $fromId: ID!
    $patientId: ID
  ) {
    createMessage(
      toIds: $toIds
      text: $text
      fromId: $fromId
      patientId: $patientId
    ) {
      id
    }
  }
`;

export default compose(
  graphql(GET_ALL_USERS_QUERY, {
    name: "getAllUsers",
    fetchPolicy: "network-only"
  }),
  graphql(CREATE_MESSAGE_MUTATION, {
    name: "createMessageMutation"
  })
)(ChatModal);



// WEBPACK FOOTER //
// ./src/components/utilities/ChatModal.js